import { render } from "./TestingConfig.vue?vue&type=template&id=6d6a026c&scoped=true&ts=true"
import script from "./TestingConfig.vue?vue&type=script&lang=ts"
export * from "./TestingConfig.vue?vue&type=script&lang=ts"

import "./TestingConfig.vue?vue&type=style&index=0&id=6d6a026c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6a026c"]])

export default __exports__